import { render, staticRenderFns } from "./order-view.vue?vue&type=template&id=14623aba&"
import script from "./order-view.vue?vue&type=script&lang=js&"
export * from "./order-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports